import interests from './interests.json';

export const programmingInterests = [
  'mtb',
  'bmx',
  'formula-one',
  'motogp',
  'motocross',
  'enduro',
  'rally',
  'drifting',
  'surfing',
  'skateboarding',
  'skiing',
  'snowboarding',
  'gaming',
  'climbing',
  'breaking',
  'dancing',
  'freerunning',
  'mc-battle',
];

export const filterInterests = (filter) => {
  let filteredInterests = {};
  if (filter === 'programming') {
    for (const interest of programmingInterests) {
      filteredInterests[interest] = {
        name: interests[interest].name,
      };
    }
  }
  return filteredInterests;
};
